import TagsSVG from '../../assets/svg/tags.svg';
export default TagsSVG;
